<template>
  <Header_en/>
  <Contact_index_en/>
  <Contact_page_en/>


</template>
<script>
import Header_en from "@/components/EN/Header_en";
import Contact_index_en from "@/components/EN/contact/Contact_index_en";
import Contact_page_en from "@/components/EN/contact/Contact_page_en";

export default {
  name: 'Contact_en',
  components: {
    Contact_index_en,
    Contact_page_en,
    Header_en,
  }
}
</script>
<style scoped>

</style>

